import React from "react";
import { Modal as AntdModal} from 'antd';
import { useStateContext } from '../../contexts/ContextProvider';

import './Modal.css'

const Modal = ({okText='ตกลง',cancelText='ยกเลิก',title, open=true, onOk, onCancel ,children ,width,loading=false }) => {
  const { currentColor} = useStateContext();
  return (
    <AntdModal
      className="custom-modal"
      width={width}
      title={title}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      okButtonProps={{ style: { backgroundColor: currentColor, borderColor: currentColor } ,loading}}
      cancelButtonProps={{ className: 'ant-btn-cancel', style: { '--cancel-button-color-hover': currentColor } }}
    >
      <hr className='line-header' />
      {children}
    </AntdModal>
  );
};


export default Modal;



